import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEditBookMutation } from '../../features/api/apiSlice';

const EditForm = ({book}) => {
    const navigate = useNavigate();
    const {name:initialName, author:initialAuthor, thumbnail:initialThumbnail, rating:initialRating, price:initialPrice, featured:initialFeatured, id } = book;
    
    const [name, setName] = useState(initialName);
    const [author, setAuthor] = useState(initialAuthor);
    const [thumbnail, setThumbnail] = useState(initialThumbnail);
    const [rating, setRating] = useState(initialRating);
    const [price, setPrice] = useState(initialPrice);
    const [featured, setFeatured] = useState(initialFeatured);

    const [editBook, {isLoading, isError, isSuccess}] = useEditBookMutation()

    const resetForm = () => {
            setName("");
            setAuthor("");
            setThumbnail("");
            setPrice(0);
            setRating(0);
            setFeatured(false);
     }

     const handleSubmit = (e) => {
        e.preventDefault();
    
        const data = {
            name,
            author,
            thumbnail,
            rating : Number(rating),
            price : Number(price),
            featured
        }
    
        editBook({data, id})
           .then((data) => {
            if(data?.data?.id){
              toast.success("Book has been edited!")  
              resetForm();
              navigate('/')
            }
            
           })
      }

    return (
        <form class="book-form" onSubmit={handleSubmit}>
                    <div class="space-y-2">
                        <label for="lws-bookName">Book Name</label>
                        <input required class="text-input" type="text" id="lws-bookName" name="name" value={name} onChange={(e) => setName(e.target.value)}/>
                    </div>

                    <div class="space-y-2">
                        <label for="lws-author">Author</label>
                        <input required class="text-input" type="text" id="lws-author" name="author" value={author} onChange={(e) => setAuthor(e.target.value)}/>
                    </div>

                    <div class="space-y-2">
                        <label for="lws-thumbnail">Image Url</label>
                        <input required class="text-input" type="text" id="lws-thumbnail" name="thumbnail" value={thumbnail} onChange={(e) => setThumbnail(e.target.value)}/>
                    </div>

                    <div class="grid grid-cols-2 gap-8 pb-4">
                        <div class="space-y-2">
                            <label for="lws-price">Price</label>
                            <input required class="text-input" type="number" id="lws-price" name="price" value={price} onChange={(e) => setPrice(e.target.value)}/>
                        </div>

                        <div class="space-y-2">
                            <label for="lws-rating">Rating</label>
                            <input required class="text-input" type="number" id="lws-rating" name="rating" min="1"
                                max="5" value={rating} onChange={(e) => setRating(e.target.value)}/>
                        </div>
                    </div>

                    <div class="flex items-center">
                        <input id="lws-featured" type="checkbox" name="featured" class="w-4 h-4" checked={featured} onChange={(e) => setFeatured(!featured)}/>
                        <label for="lws-featured" class="ml-2 text-sm"> This is a featured book </label>
                    </div>

                    <button type="submit" class="submit" id="lws-submit">Edit Book</button>
                </form>
    );
};

export default EditForm;